import { useAutoneTranslation } from '@autone/translations';
import { forwardRef, type MouseEvent } from 'react';

import { Button, type ButtonProps } from '../../../../../../tailwind';
import { useChangeFiltersPopoverViewContext } from '../../../ChangeFiltersPopoverView.context';

export const SaveFilterButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, onClick, ...props }, ref) => {
    const { common } = useAutoneTranslation();
    const [, dispatch] = useChangeFiltersPopoverViewContext();
    const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
      dispatch({ type: 'GO_BACK' });
      onClick?.(e);
    };
    return (
      <Button
        onClick={handleClick}
        variant="contained"
        color="primary"
        className={className}
        ref={ref}
        {...props}
      >
        {common('filters.save-filter')}
      </Button>
    );
  },
);
